/* THETA dark room: behaviour and measurement.
   Events go to Shopify Customer Events (Shopify.analytics.publish, read by custom pixels)
   and to window.dataLayer (read by GTM if installed). Names are prefixed theta_. */
(function () {
  'use strict';
  if (window.__thetaDarkRoom) return;
  window.__thetaDarkRoom = true;
  var doc = document.documentElement;
  doc.classList.add('th-js');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CTX = window.THETA_CTX || {};
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- measurement ---------- */
  function track(name, data) {
    var payload = Object.assign({ page_type: CTX.pageType || '', path: location.pathname }, data || {});
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, payload); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload)); } catch (e) {}
  }
  window.thetaTrack = track;

  // any element with data-th-track="event_name" and data-th-* params
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-th-track]');
    if (!el) return;
    var data = {};
    Object.keys(el.dataset).forEach(function (k) {
      if (k !== 'thTrack' && k.indexOf('th') === 0) data[k.slice(2).replace(/^./, function (c) { return c.toLowerCase(); }).replace(/[A-Z]/g, function (c) { return '_' + c.toLowerCase(); })] = el.dataset[k];
    });
    if (el.href) data.destination = el.href;
    track(el.dataset.thTrack, data);
  }, true);

  // sections seen (once each, half on screen)
  if ('IntersectionObserver' in window) {
    var seenIO = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { track('theta_section_view', { section: en.target.getAttribute('data-th-section') }); seenIO.unobserve(en.target); } });
    }, { threshold: .5 });
    $$('[data-th-section]').forEach(function (s) { seenIO.observe(s); });
  }

  // bridge Ira's cart and product events into the same stream
  document.addEventListener('flu:quick-cart:open', function () { track('theta_cart_open', {}); });
  document.addEventListener('flu:product:variant-change', function (e) {
    var v = e.detail && e.detail.variant; if (v) track('theta_variant_change', { variant_id: v.id, variant_title: v.title, available: v.available });
  });

  /* ---------- header and race strip ---------- */
  var SEGS = ['Run 1', 'SkiErg', 'Run 2', 'Sled push', 'Run 3', 'Sled pull', 'Run 4', 'Burpee broad jumps', 'Run 5', 'Rowing', 'Run 6', 'Farmers carry', 'Run 7', 'Sandbag lunges', 'Run 8', 'Wall balls'];
  var hdr = $('[data-th-header]'), strip = $('[data-th-strip]'), segName = $('[data-th-seg]'), hero = $('[data-th-hero]');
  if (strip && !strip.children.length) strip.innerHTML = SEGS.map(function (s, i) { return '<i class="' + (i % 2 ? 'st' : '') + '"></i>'; }).join('');
  var segEls = strip ? strip.children : [], lastQuarter = 0;
  function onScroll() {
    var y = window.scrollY, max = Math.max(1, document.documentElement.scrollHeight - innerHeight), p = y / max;
    var n = Math.min(15, Math.floor(p * 16));
    for (var i = 0; i < segEls.length; i++) segEls[i].classList.toggle('done', i <= n);
    if (segName) segName.textContent = SEGS[n];
    if (hdr && hero) hdr.classList.toggle('is-over', y < hero.offsetHeight - 80);
    var q = Math.floor(p * 4) * 25;
    if (q > lastQuarter) { lastQuarter = q; track('theta_scroll_depth', { depth: q, station: SEGS[n] }); }
  }
  addEventListener('scroll', onScroll, { passive: true }); addEventListener('resize', onScroll); onScroll();

  /* ---------- films ---------- */
  function setupFilm(v) {
    var rate = parseFloat(v.getAttribute('data-rate') || '1');
    var pick = function () {
      var tall = matchMedia('(max-aspect-ratio: 4/5)').matches;
      var src = (tall && v.getAttribute('data-src-tall')) || v.getAttribute('data-src');
      var poster = (tall && v.getAttribute('data-poster-tall')) || v.getAttribute('data-poster');
      if (poster) v.poster = poster;
      if (src && v.getAttribute('src') !== src) { v.src = src; v.load(); }
    };
    v.muted = true; v.playsInline = true; v.loop = true;
    v.addEventListener('loadedmetadata', function () { try { v.playbackRate = rate; } catch (e) {} });
    v.addEventListener('play', function () { try { v.playbackRate = rate; } catch (e) {} });
    var paused = reduce, visible = false;
    var ctlId = v.getAttribute('data-ctl'), ctl = ctlId && document.getElementById(ctlId);
    function sync() { if (ctl) { ctl.textContent = paused ? 'Play film' : 'Pause film'; ctl.setAttribute('aria-pressed', String(paused)); } }
    function go() { if (!paused && visible && !document.hidden) v.play().catch(function () {}); else v.pause(); }
    if (ctl) ctl.addEventListener('click', function () { paused = !paused; sync(); go(); track('theta_film', { film: v.getAttribute('data-film'), action: paused ? 'pause' : 'play' }); });
    document.addEventListener('visibilitychange', go);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { visible = e.isIntersecting; if (visible && !v.getAttribute('src')) pick(); go(); }); }, { rootMargin: '200px 0px' }).observe(v);
    } else { visible = true; pick(); go(); }
    var mq = matchMedia('(max-aspect-ratio: 4/5)'); (mq.addEventListener ? mq.addEventListener('change', pick) : mq.addListener(pick));
    if (v.hasAttribute('data-eager')) pick();
    sync();
  }
  $$('video[data-th-film]').forEach(setupFilm);

  /* ---------- stations line: one lit at a time ---------- */
  $$('[data-th-stations]').forEach(function (p) {
    var sts = $$('.st', p), i = 0;
    function next() { sts.forEach(function (s, k) { s.classList.toggle('lit', k === i); }); i = (i + 1) % sts.length; }
    next(); if (!reduce) setInterval(function () { if (!document.hidden) next(); }, 2000);
  });

  /* ---------- Blueprint portrait: slow crossfade ---------- */
  $$('[data-th-crossfade]').forEach(function (box) {
    var imgs = $$('img', box), i = 0;
    if (imgs.length < 2 || reduce) return;
    setInterval(function () { if (document.hidden) return; imgs[i].classList.remove('on'); i = (i + 1) % imgs.length; imgs[i].classList.add('on'); }, 6000);
  });

  /* ---------- newsletter ---------- */
  $$('form[data-th-newsletter]').forEach(function (f) {
    f.addEventListener('submit', function () { track('theta_newsletter_submit', { placement: f.getAttribute('data-th-newsletter') }); });
  });

  /* ---------- mobile menu: open Ira's drawer ---------- */
  $$('[data-th-menu]').forEach(function (b) {
    b.addEventListener('click', function () { var ira = $('[data-js-menu-button]'); if (ira) ira.click(); track('theta_nav_click', { label: 'menu' }); });
  });

  /* ---------- entrances ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('seen'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -12% 0px' });
    $$('.th-in').forEach(function (el) { io.observe(el); });
  } else $$('.th-in').forEach(function (el) { el.classList.add('seen'); });

  requestAnimationFrame(function () { doc.classList.add('th-ready'); });
})();
